module.exports = __webpack_public_path__ + "static/media/llantas-rodando.b94a44c4.svg";